import React from 'react';
import { padEnd } from 'lodash';

import { SimpleTable } from '@zapier/common-components';

import { useCurrentPlan } from '@zapier/design-system-revenue/src/utils';
import { PlanTier } from '@zapier/design-system-revenue/src/types';

type MeteredTiersTableProps = {
  /** If not provided, component will retrieve tiers from the user's current plan. */
  tiers?: PlanTier[];
};

const formatTier = (numTasks: number, tierIndex: number) =>
  numTasks === -1
    ? 'Any Additional'
    : `${tierIndex === 0 ? 'First' : 'Next'} ${numTasks.toLocaleString(
        'en-US'
      )}`;

// Price is fraction of a cent. Should be at most 4
// digits after decimal and we'd like them all to be
// even, so pad them with 0.
const formatPrice = (price: number) =>
  price === 0 ? 'Included' : padEnd(`$${price / 100} USD`, 7, '0');

const formatTiers = (data: PlanTier[] = []) => {
  return [
    ['Tasks', 'Price Per Task'],
    ...data.map((tier, i) => [
      formatTier(tier.numTasks, i),
      formatPrice(tier.pricePerTask),
    ]),
  ];
};

export const MeteredTiersTable = ({ tiers }: MeteredTiersTableProps) => {
  const { currentPlan } = useCurrentPlan({ skip: !!tiers });
  const planTiers = tiers ?? currentPlan?.tiers ?? [];

  return planTiers.length > 0 ? (
    <SimpleTable data={formatTiers(planTiers)} />
  ) : null;
};
